import { render, staticRenderFns } from "./filter-person.vue?vue&type=template&id=594a0756&scoped=true&"
import script from "./filter-person.vue?vue&type=script&lang=js&"
export * from "./filter-person.vue?vue&type=script&lang=js&"
import style0 from "./filter-person.vue?vue&type=style&index=0&id=594a0756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594a0756",
  null
  
)

export default component.exports